import type { State, Course, CourseDetail } from './vuex';
import type { Filters } from '@/views/Enrollments/List';

export default {
  setCourses(state: State, courses: Course[]): void {
    state.courses = courses;
  },

  setCourse(state: State, course: CourseDetail): void {
    state.course = course;
  },

  loadMoreCourses(state: State, courses: Course[]): void {
    const currentCourses = state.courses;

    state.courses = courses;
    state.courses.unshift(...currentCourses);
  },

  setFilters(state: State, filters: Filters): void {
    state.filters = filters;
  },

  setSort(state: State, sort: string): void {
    state.sort = sort;
  },

  setPageNumber(state: State, pageNumber: number): void {
    state.pageNumber = pageNumber;
  },
};
